import { StoreType } from '@tock/shared/utils/connect';
import { createSelector } from 'reselect';
import { tableOccupancySelector } from 'selectors/tableOccupancySelector';

export const makeTableOccupancySelector = () =>
  createSelector(
    [
      (state: StoreType) => state,
      (_: StoreType, dateTime: string) => dateTime,
      (_: StoreType, __: string, turnTime: number) => turnTime,
    ],
    (state, dateTime, turnTime) =>
      tableOccupancySelector(state, {
        startDateTimeString: dateTime,
        turnTimeMinutes: turnTime,
      })
  );
